<template>
  <div>
<div class="bg-white pdb-24">
      <div class="container container--narrow pdt-50 pdb-50">
          <div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
            {{ question.number }}. {{ question.contents.text }}
            <span class="t-color-mainBtn" v-if="question.essential">*</span>
          </div>
          <div class="mgt-16" v-if="question.contents && question.contents.image">
            <img :src="question.contents.image" alt="" class="b-radius4  survey-banner" />
          </div>
          <!-- <div class=""  
            v-for="(choice, index) in question.choices" :class="index == 0 ? 'mgt-24' : 'mgt-16'" :key="index+'rank'">
             <label
                  class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 mdc-text-field--disabled disabled--Updated"
                  data-mdc-auto-init="MDCTextField">
                  <span class="mdc-notched-outline">
                      <span class="mdc-notched-outline__leading"></span>
                      
                      <span class="mdc-notched-outline__trailing"></span>
                  </span> 
                  <input class="mdc-text-field__input z-99 " 
                    type="text" 
                    :value="choice.contents"
                    readonly disabled/>
                  
              </label> 
          </div> -->
          <div v-for="(choice, index) in question.choices" :key="index+'rank'"> 
            <div class="mgb-8 mdc-select mdc-select--outlined w-full mdc--select__custom mdc-select--no-label"
                data-mdc-auto-init="MDCSelect">
                <div class="mdc-select__anchor h-46" aria-labelledby="outlined-select-label">
                  <select
                    class="mdc-select__native-control mdc-select--outlined w-full mgt-8 mgr-8"
                    disabled
                  >
                    <option
                      :key="index+1"
                      :value="index+1"
                      :selected="true"
                    >
                      {{ choice.contents }}
                    </option>
                  </select>
                  <div class="mdc-notched-outline">
                      <div class="mdc-notched-outline__leading"></div>
                      <div class="mdc-notched-outline__notch">
                        <!-- <label class="mdc-floating-label"></label> -->
                      </div>
                      <div class="mdc-notched-outline__trailing"></div>
                    </div>
                </div>
            </div>
          </div>
      </div>
  </div>
  <div class="divider"></div>
  <div class="container container--narrow pdb-50">
      <div class="pdt-24 t-subtitle6 font-r l-spacing54">{{ $t("743") }}</div>
      <div class="mgt-16">
          <div class="mgb-8 mdc-select mdc-select--outlined w-full mdc--select__custom mdc-select--no-label resposib"
              data-mdc-auto-init="MDCSelect" :class="selectedChoiceId !==null?'hasActiveVal':''">
              <div class="mdc-select__anchor h-46" aria-labelledby="outlined-select-label">
                <select
                  class="mdc-select__native-control mdc-select--outlined w-full mgt-8 mgr-8"
                  v-model="selectedChoiceId"
                  @change="setChoiceFeedback()"
                  
                >
                  <option
                    v-for="choice in question.choices"
                    :key="choice.id"
                    :value="choice.id"
                  >
                    {{ choice.contents }}
                  </option>
                </select>
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                      <!-- <label class="mdc-floating-label"></label> -->
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                  </div>
              </div>
          </div>
      </div>
      <div class="mgt-21">
          <div class="d-flex justify-content-between align-items-center mgb-15"           
          v-for="(choice, index) in choiceFeedback"
          :key="index">
              <div class="t-body6 font-r t-color-bodyGrayA l-spacing45">{{ $t("744", { str: index + 1 }) }}</div>
              <div class="t-subtitle3 font-rn">{{ choice.count }}</div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
/**
 * 설문 - 순위선택형 문항 피드백 컴포넌트(survey - select ranking question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import surveyApi from "@/api/surveyApi.js";
import { MDCSelect } from "@material/select";
import { MDCTextField } from "@material/textfield";

export default {
  props: ["question", "eachViewFeedback"],
  data() {
    return {
      selectedChoiceId: null,
      choiceFeedback: [],
      baseRanks: {}
    };
  },

  mounted() {
    this.attachMertial();
    this.setChoiceFeedback();
    //this.baseRanks = this.createOptions(this.question);
  },

  methods: {
     
    attachMertial() {
      const inputElement = [].map.call(
        document.querySelectorAll(".mdc-text-field"),
        function (el) {
          let input = new MDCTextField.attachTo(el);
          return input;
        }
      );

      const selectElement = [].map.call(
        document.querySelectorAll(".mdc-select"),
        function (el) {
          let select = new MDCSelect.attachTo(el);
          return select;
        }
      );
    },

    // get ranking feedback data
    setChoiceFeedback() {
      if (!this.selectedChoiceId) {
        this.selectedChoiceId = this.question.choices[0].id;
      }

      let params = {
        questionId: this.question.questionId,
        choiceId: this.selectedChoiceId,
      };

      surveyApi.surveyQuestionRankingChoiceFeedback(params).then((response) => {
        this.choiceFeedback = response.data.data;
      });
    },
  },
};
</script>

<style scoped>
  .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__leading, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__notch, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__trailing{
	border-color: var(--Textfeildactive);
}

.mdc-select--outlined.hasActiveVal select  {
  color: var(--HeadlineBlack) !important;
}

.mdc-select--outlined.resposib select option {
	color: var(--BodygrayA) !important;
}
</style>
